export default "__VITE_ASSET__bc353cjm__"